
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface HeroProps {
  onPledge: () => void;
}

const Hero = ({ onPledge }: HeroProps) => {
  return (
    <div className="relative max-w-4xl mx-auto text-center space-y-8 z-10">
      <span className="premium-subtitle text-accent">Financial Revolution • December 2025</span>
      <h1 className="premium-title text-4xl md:text-5xl lg:text-6xl fade-in stagger-1">
        <span className="text-foreground">
          Your Money, Your
        </span>
        {" "}
        <span className="bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent animate-gradient">
          Data, Your Future
        </span>
      </h1>
      <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto fade-in stagger-2">
        We believe in a financial world where the power of your data serves you, not corporations.
      </p>
      <div className="pt-4 fade-in stagger-3">
        <Button 
          size="lg"
          onClick={onPledge}
          className="text-lg py-6 px-8"
        >
          Support The Movement
          <ArrowRight className="ml-2 transition-transform group-hover:translate-x-1" />
        </Button>
      </div>
    </div>
  );
};

export default Hero;
